<template>
  <v-layout column>
    <v-flex xs6 offset-xs0>
      <panel title="Login">
        <div slot="top">
         <v-text-field v-model="email" name='email' label="Email" />
          <br/>
          <v-text-field v-model="password" name='password' label="Password" 
          :append-icon="showP ? 'visibility' : 'visibility_off'"   
           :type="showP ? 'text' : 'password'"       
            @click:append="showP = !showP"/>
          <br/>
          <div class="danger-alert" v-html="error">
          </div>
          <div class="message" v-html="message">
          </div>
          <br/>
          <v-btn dark class="indigo darken-1" @click='login'>Login</v-btn>
        </div>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import Panel from '@/components/Panel'
import AuthenticationService from '@/services/AuthenticationService'
export default {
  components: {
    Panel
  },  
  data () {
    return {
      email: '',
      password: '',
      error: null,
      message: null,
      showP: false
    }
  },
  methods: {
    async login () {     
      console.log("IN LOGIN") ; 
      this.error = null ;
      try {
        const response = await AuthenticationService.login({
          email: this.email,
          password: this.password
        })
        console.log("logon good: " + response.data) 
        this.$store.dispatch('setUserAndToken', {user: response.data.user, token: response.data.token}) ;
        console.log("done store dispatch setUserandToken") ;
        this.message = response.data.message
        this.$router.push({name:'home'}) ;
      }
      catch (error) {
        this.error = error.response.data.error ;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.danger-alert {color:red;background:white;font-size:120%}
.message {color:green}
.input-group00text-field input {
  border-bottom: 1px solid black ;
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue